export default "__VITE_ASSET__D2vN3Mh2__"